<template>
  <b-modal
      :visible="visible"
      ref="modal"
      id="admin-strain-edit-modal"
      title="Edit Strain"
      @hidden="$emit('cancel')"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Strain Name">
        <b-form-input
            v-model.trim="formData.name"
            type="text"
            :state="fieldValid('name')"
        />
        <b-form-invalid-feedback :state="fieldValid('name')">
          {{ formValidation.name }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="success" :disabled="formState.processing">
        Submit
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>
<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminStrainEditModal",
  emits: ['success', 'cancel'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    strain: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      formData: {
        name: this.strain.name
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  computed: {
    strainTypes() {
      return this.$store.state.data.strain_types.map(ct => ({
        value: ct.id,
        text: ct.name
      }));
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-strain-edit-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-strain-edit-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(`${API_ROUTES.ADMIN_TAXONOMY_STRAINS}/${this.strain.id}`, this.formData).then(({data}) => {
        this.formValidation = {};
        this.$emit('success', data.strain);
        this.close();
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new strain', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
